import React from "react"
import { Link, useParams } from "react-router-dom"

import ActivityBase from "@/components/activities/base"
import OwnerLabel from "@/components/activities/owner_label"
import i18n from "@/i18n"
import { reservationEditPath } from "@/shared/urls"
import { ActivityReservationRemoved } from "@/types/activities"

interface RemovedProps {
  activity: ActivityReservationRemoved & { resource?: { __typename: string; id: string } | null }
  className?: string
}

const Removed = ({ activity, className }: RemovedProps) => {
  const { slug } = useParams<{ slug: string }>()

  const resourceLink =
    activity.resource?.__typename === "Reservation" && slug ? (
      <Link to={reservationEditPath(slug, activity.resource.id)} className="text-blue-500 hover:underline">
        #{activity.resource.id}
      </Link>
    ) : null

  return (
    <ActivityBase
      data-testid="panel-activity-reservation-removed"
      activityKey={activity.key}
      createdAt={activity.createdAt}
      text={i18n.react("app.activities.reservation.removed.description", {
        owner: <OwnerLabel owner={activity.owner} />,
        resourceLink,
      })}
      className={className}
    />
  )
}

export default Removed
